var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Whatsapp icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconWhatsapp extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.2 23.2C1.4 23.4 1.6 23.5 1.8 23.5L1.9 23.4L7.6 22.4C9.1 23 10.7 23.4 12.3 23.4C15.2 23.4 18.1 22.2 20.2 20.1C22.3 18 23.5 15.2 23.5 12.2C23.5 9.3 22.3 6.4 20.2 4.3C18.1 2.2 15.3 1 12.3 1C6.2 1 1.1 6.1 1 12.3C1 14.4 1.6 16.4 2.7 18.2L1.1 22.5C1 22.7 1 23 1.2 23.2ZM8 21C7.9 20.9 7.8 20.9 7.7 20.9H7.6L3 21.7L4.3 18.3C4.4 18.1 4.3 17.8 4.2 17.6C3.2 16 2.6 14.1 2.6 12.2C2.6 7 7 2.5 12.3 2.5C14.9 2.5 17.3 3.4 19.2 5.3C21.1 7.2 22.1 9.6 22.1 12.2C22.1 14.8 21.1 17.2 19.2 19.1C17.3 21 14.9 22 12.3 22C10.8 22 9.3 21.6 8 21ZM12.3997 17.4001C12.9997 17.8001 13.5997 18.0001 14.2997 18.0001C15.2997 18.0001 16.2997 17.6001 17.0997 16.7001C17.5997 16.3001 17.7997 15.8001 17.8997 15.2001C17.8997 14.6001 17.6997 13.9001 17.1997 13.4001L15.9997 12.1001C15.8997 12.0001 15.6997 11.9001 15.4997 11.9001C15.3997 11.9001 15.0997 12.0001 14.9997 12.1001C14.6997 12.4001 14.0997 12.5001 13.7997 12.4001C12.6997 12.0001 12.2997 11.5001 11.8997 10.9001C11.5997 10.5001 11.9997 9.7001 12.2997 9.4001C12.3997 9.3001 12.4997 9.1001 12.4997 8.9001C12.4997 8.7001 12.4997 8.5001 12.2997 8.4001L10.9997 7.2001C10.4997 6.8001 9.89975 6.6001 9.29975 6.6001C8.79975 6.7001 8.29975 6.9001 7.99975 7.3001C6.89975 8.6001 6.09975 10.7001 7.09975 12.2001C8.39975 14.2001 10.1997 16.0001 12.3997 17.4001ZM9.19975 8.3001C9.29975 8.2001 9.39975 8.2001 9.59975 8.2001C9.69975 8.2001 9.89975 8.3001 10.0997 8.4001L10.8997 9.1001C10.4997 9.9001 10.1997 11.0001 10.7997 11.9001C11.2997 12.7001 11.9997 13.5001 13.4997 14.0001C14.1997 14.2001 14.9997 14.1001 15.5997 13.8001L16.3997 14.6001C16.4997 14.8001 16.5997 15.1001 16.5997 15.3001C16.5997 15.5001 16.4997 15.6001 16.3997 15.7001C15.1997 16.6001 14.1997 16.8001 13.2997 16.2001C11.2997 14.9001 9.59975 13.3001 8.39975 11.4001C7.89975 10.7001 8.49975 9.2001 9.19975 8.3001Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconWhatsapp.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconWhatsapp.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconWhatsapp.prototype, "size", void 0);
if (customElements.get('cat-icon-whatsapp') === undefined) {
    customElements.define('cat-icon-whatsapp', BlocksIconWhatsapp);
}
